
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M19.206 16.813v5.512a2.622 2.622 0 01-2.62 2.62H15.4a.874.874 0 00-.875.875v3.144l-4.134-3.791a.869.869 0 00-.591-.228H3.62A2.628 2.628 0 011 22.321v-7.637a2.622 2.622 0 012.62-2.62h5.464a4.376 4.376 0 004.29 3.567h.312v4.254a.869.869 0 00.523.8.871.871 0 00.943-.152z"}}),_c('path',{attrs:{"d":"M13.374 1a2.622 2.622 0 00-2.62 2.62v7.641a2.622 2.622 0 002.62 2.62h1.18a.874.874 0 01.875.875V17.9l4.138-3.787a.869.869 0 01.591-.228h6.186a2.622 2.622 0 002.62-2.62V3.62A2.628 2.628 0 0026.34 1z"}})])])
          )
        }
      }
    